
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import ukran from "../../assets/ukran.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarUkran({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar ukrán fordító</title>
                <meta name='description' content="Ingyenes magyar ukrán fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar ukrán fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-ukran-fordito" />
            </Helmet>
            <h1>Magyar ukrán fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és ukrán nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={ukran} alt="ukrán zászló"></img>
                </div>


                <p>Íme néhány alapvető különbség az ukrán és a magyar nyelv között:</p>

                <h3>Hangrendszer</h3>

                <p>Az ukrán nyelvben találhatók hangok, amelyek a magyar nyelvben nem léteznek, és fordítva. Például az ukránban előfordulnak az "ö" és "i" hangok, amelyek nincsenek meg a magyarban.</p>
                
                <h3>Írásrendszer</h3>

                <p>Az ukrán nyelv cirill betűs írásrendszert használ, míg a magyar nyelvben latin betűkkel írnak.</p>
               
                <h3>Nyelvtani szerkezet</h3>

                <p>Az ukrán nyelv flektáló jellegű, ami azt jelenti, hogy a szavak és a mondatok nyelvtani jellemzőit a ragokkal és a különböző nyelvtani kategóriákkal fejezik ki. A magyar nyelvben is vannak némi flektáló jellegű elemek, de általában az agglutináló jelleg a domináns.</p>
               
                <h3>Szórend</h3>

                <p>Az ukrán nyelvben a szórend gyakran SV(O) (alany-ige-állítmány) vagy SVO (alany-ige-állítmány-tárgy) lehet. A magyar nyelvben a szabad szórend jellemző, ami azt jelenti, hogy a mondat elemeit a hangsúly és a kontextus alapján helyezik el.</p>
              
                <h3>Szókincs</h3>

                <p>Az ukrán és a magyar nyelv szókincse is különbözik egymástól. Míg néhány alapvető szóban lehetnek hasonlóságok, a kifejezések, a szakzsargon és a mindennapi szóhasználatban jelentős eltérések vannak.</p>

                <div className="sectionbottom">
                    <Link to="/ukran-magyar-fordito">Ukrán magyar fordító</Link>
                    <img src={ukran} alt="ukrán zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarUkran;